import Container from "./container";
import React from "react";
import { cn } from "../lib/helpers";
import Links from "./links";
import SubscriptionForm from "./subscription-form";

import * as styles from "../styles/components/page-header.module.css";

const PageHeader = (props) => {
  const {
    title,
    subtitle,
    description,
    button,
    link,
    titleWidth,
    descWidth,
    dark,
    pricingPage,
    isBlogMainPage
  } = props;

  return (
    <div className={cn(styles.root, dark && styles.dark, pricingPage && styles.pricingPage)}>
      <Container>
        <div className={"content-"+titleWidth}>
          {subtitle && <div className={cn("h6", styles.subtitle)}>{subtitle}</div>}
          {title && <h1 className={cn("h2", styles.title)}>{title}</h1>}
        </div>
        {(description || (button && button.url) || (link && link.url)) &&
          <div className={"content-"+descWidth}>
            {description && <p>{description}</p>}
            {((button && button.url) || (link && link.url)) &&
              <Links button={button} link={link} dark={dark} />
            }
          </div>
        }
      </Container>
      { isBlogMainPage &&
        <div className={styles.subscriptionContainer}>
          <div className={styles.subscription}>
            <SubscriptionForm />
          </div>
        </div>
      }
    </div>
  );
}

export default PageHeader;
